function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-479.5 -464.5)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(479.5 477.615)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M498.374,511.385H480.626a1.138,1.138,0,0,1-1.126-1.148v-1.311a.492.492,0,0,1,.256-.432l7.213-3.935a.492.492,0,0,1,.471.864l-6.957,3.8v1.019a.156.156,0,0,0,.142.164h17.748a.156.156,0,0,0,.142-.164v-1.02l-6.947-3.794a.492.492,0,0,1,.471-.863l7.2,3.934a.491.491,0,0,1,.256.431v1.312A1.138,1.138,0,0,1,498.374,511.385Z",
  transform: "translate(-479.5 -504.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(484.09 464.5)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M501.215,478.6a.492.492,0,0,1-.252-.914c2.338-1.4,2.373-5.167,2.373-5.205l0-3.7c-.348-1.932-2.575-3.279-4.39-3.3h-.034c-1.822,0-4.074,1.351-4.422,3.295l0,3.7c0,.036.036,3.706,2.4,5.21a.492.492,0,1,1-.529.829c-2.818-1.8-2.85-5.868-2.85-6.04l0-3.744a.5.5,0,0,1,.007-.08c.41-2.472,3.1-4.137,5.362-4.155h.038c2.274,0,4.987,1.67,5.4,4.156a.51.51,0,0,1,.007.081l0,3.743c0,.178-.032,4.366-2.852,6.049A.488.488,0,0,1,501.215,478.6Z",
  transform: "translate(-493.5 -464.5)"
})));

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgProfile, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Profile.b670d562.svg";
export { ForwardRef as ReactComponent };